import React from 'react';

export const diamondPath = 'M 32 .2 L 63.8 32 L 32 63.8 L .2 32 L 32 .2 z';
export default class Diamond extends React.PureComponent {
  render() {
    return <path d={diamondPath} className="fill-current" />;
  }
}
